import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "aos/dist/aos.css";
import AOS from "aos";
import Footer from "../Home/Footer";
import "./Articles.css";
import Article1 from "../assets/img/PolicyMeetings3.png";
import Article2 from "../assets/img/Article2.png";
import Article3 from "../assets/img/Article3.png";
import Article4 from "../assets/img/Article4.jpg";
import Article5 from "../assets/img/Article5.jpg";
import Article6 from "../assets/img/Article6.jpg";
import Article7 from "../assets/img/Article7.jpg";

const linkedinPosts = [
  {
    id: 1,
    title: "IPDA PDG Meeting on Alternative Protein",
    url: "https://www.linkedin.com/posts/indo-pulses-development-association-ipda_ipda-pdgmeeting-alternativeprotein-activity-7342898806608302080-Rzjj",
    image: Article1,
  },
  {
    id: 2,
    title: "ICRISAT MOU Signing with IPDA",
    url: "https://www.linkedin.com/posts/indo-pulses-development-association-ipda_icrisat-signed-a-memorandum-of-understanding-activity-7325851224283496448-TDgE",
    image: Article4,
  },
  {
    id: 2,
    title: "Pulses Farmers Initiative by VSTF",
    url: "https://www.linkedin.com/posts/village-social-transformation-foundation_pulses-farmers-vstf-ugcPost-7343244972592107520-d069",
    image: Article2,
  },
  {
    id: 4,
    title: "Mumbai Pulse Event - Maharashtra",
    url: "https://www.linkedin.com/posts/village-social-transformation-foundation_mumbai-pulse-maharashtra-ugcPost-7343246176869089283-tY9i",
    image: Article3,
  },

  {
    id: 5,
    title: "Indo Pulses Development Association Event",
    url: "https://www.linkedin.com/posts/anjali-847a14244_the-indo-pulses-development-association-activity-7298760403008823297-VjK4",
    image: Article5,
  },
  {
    id: 6,
    title: "Webinar on Pulse Processing for FPOs",
    url: "https://www.linkedin.com/posts/dr-shubhra-deshpande-4b352023_webinar-pulseprocessing-fpos-activity-7272225481142263809-mXEA",
    image: Article6,
  },

  {
    id: 7,
    title:
      "Building Maharashtra's First Pulse Protein Processing Cluster: A Shared Vision for India's Protein Economy",
    url: "https://www.linkedin.com/posts/indo-pulses-development-association-ipda_building-maharashtras-first-pulse-protein-activity-7487406477914267649-2XJ1?utm_source=share&utm_medium=member_android&rcm=ACoAAETxJYsBXFz_rxkkh4HmMpqBPgPnFKCowDY",
    image: Article7,
  },
];

const Articles = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <div className="articles-page">
      {/* Hero Section */}
      <section className="articles-hero">
        <div className="container text-center">
          <h1 data-aos="fade-up">Latest Updates & Articles</h1>
          <div className="separator-line mb-5"></div>
          <p data-aos="fade-up" data-aos-delay="100">
            Explore our latest activities, insights, and industry news.
          </p>
        </div>
        <div className="wave-divider"></div>
      </section>

      {/* Articles Grid */}
      <section className="articles-content py-2">
        <div className="container">
          <div className="row justify-content-center">
            {linkedinPosts.map((post) => (
              <div
                className="col-md-6 col-lg-4 mb-4"
                key={post.id}
                data-aos="fade-up"
              >
                <a
                  href={post.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="article-tile"
                >
                  <div className="article-image">
                    <img src={post.image} alt={post.title} />
                  </div>
                  <div className="article-info">
                    <h3>{post.title}</h3>
                    <span className="read-more">Read More →</span>
                  </div>
                </a>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Articles;
